import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  ToggleSwitchDefinition,
  IToggleSwitchMapperProps,
} from '../ToggleSwitch.types';

const props = withCompPreviewProps<
  IToggleSwitchMapperProps,
  ToggleSwitchDefinition
>()(
  // componentViewMode is a dependency in order to reset props according to initial state in editor.
  ['compData', 'compProps', 'compPreviewState', 'hasResponsiveLayout'],
  ({ compData, compProps, compPreviewState, hasResponsiveLayout }) => {
    let checked = compData.checked;

    if (compPreviewState) {
      if (compPreviewState.includes('checked')) {
        compPreviewState = compPreviewState
          .split(' ')
          .filter(item => item !== 'checked')
          .join(' ');
        checked = true;
      } else {
        checked = false;
      }
    }

    return {
      checked,
      value: compData.value,
      label: compProps.label,
      isDisabled: compProps.isDisabled,
      hasResponsiveLayout,
      previewWrapperProps: {
        compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
